// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__sFReK","media":"style_media__S+OOh","main_price":"style_main_price__q6K8m","main_btn":"style_main_btn__TCS-3"};